import React from 'react';
import InputTextEditComponent from '../../../../components/inputTextEdit/inputTextEdit_component';
import InputTextComponent from '../../../../components/inputText/inputText_component';
import { updateCorreoCelular } from '../../../../redux/reducers/simuladorFVGSlice';
import { useDispatch, useSelector } from 'react-redux';

const EloquaFormComponent = ({
  celular,
  correoEle,
  msgCorreoEle,
  guardarMsgCorreoEle,
  guardarCorreoEle,
  guardarCelular,
  msgCelular,
  guardarMsgCelular,
  terminosConfirma,
  guardarMsgTerminos,
  onClose,
  mostrarSuccessMessage,
}) => {
  const dispatch = useDispatch();
  const simuladorFVG = useSelector((state) => state.rootReducers.simuladorFVG);

  const [formData] = React.useState({
    elqFormName: 'FormularioFVG',
    elqSiteId: '6228171',
    elqCampaignId: '',
    origen: '~~eloqua..type--emailfield..syntax--Origen1~~',
    from: '~~eloqua..type--emailfield..syntax--From1~~',
    utm_medium: '~~eloqua..type--emailfield..syntax--utm_medium1~~',
    utm_source: '~~eloqua..type--emailfield..syntax--utm_source1~~',
    utm_content: '~~eloqua..type--emailfield..syntax--utm_content1~~',
    utm_campaign: '~~eloqua..type--emailfield..syntax--utm_campaign1~~',
    lastName: '',
    secondLastName: '',
    canalOrigen: 'FFVV',
    producto: 'FVG_EC',
    urlConfirmacion: '',
    enviarCRM: process.env.REACT_APP_ENVIAR_CRM_ELOQUA,
  });

  const handleSubmit = (e) => {
    e.preventDefault();

    if (simuladorFVG.nombreProspecto && !terminosConfirma) {
      guardarMsgTerminos('Debe aceptar las condiciones establecidas');
      return false;
    }

    const form = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
      form.append(key, value);
    });

    form.append('telefono', celular);
    form.append('email', correoEle);
    form.append('numDoc', simuladorFVG.nroDocumento);
    form.append('firstName', simuladorFVG.nombre);

    fetch('https://s6228171.t.eloqua.com/e/f2', {
      method: 'POST',
      body: form,
    })
      .then((response) => {
        if (response.ok) {
          onClose();
          if (mostrarSuccessMessage) {
            setTimeout(() => {
              mostrarSuccessMessage(true);
            }, [400]);
          }
        } else {
          console.error('Form submission failed');
        }
      })
      .catch((error) => {
        console.error('Error submitting form:', error);
      });

    dispatch(
      updateCorreoCelular({
        celular: celular,
        correoEle: correoEle,
      })
    );
  };

  return (
    <form
      method="post"
      name="FormularioFVG"
      onSubmit={handleSubmit}
      id="form70"
      className="elq-form"
    >
      <InputTextEditComponent
        inputText={'Celular'}
        inputValue={celular}
        inputAction={guardarCelular}
        inputWidth={100}
        type={'number'}
        inputMsg={msgCelular}
        inputActionMsg={guardarMsgCelular}
      />
      <InputTextEditComponent
        inputText={'Correo'}
        inputValue={correoEle}
        inputAction={guardarCorreoEle}
        inputWidth={100}
        type={'text'}
        inputMsg={msgCorreoEle}
        inputActionMsg={guardarMsgCorreoEle}
      />
      <InputTextComponent
        inputText={'elqFormName'}
        inputValue={formData.elqFormName}
        type={'hidden'}
      />
      <InputTextComponent
        inputText={'elqSiteId'}
        value={formData.elqSiteId}
        type={'hidden'}
      />
      <InputTextComponent
        inputText={'elqCampaignId'}
        value={formData.elqCampaignId}
        type={'hidden'}
      />
      <InputTextComponent
        inputText={'origen'}
        value={formData.origen}
        type={'hidden'}
        id="fe1005"
      />
      <InputTextComponent
        inputText={'from'}
        value={formData.from}
        type={'hidden'}
        id="fe1006"
      />
      <InputTextComponent
        inputText={'utm_medium'}
        value={formData.utm_medium}
        type={'hidden'}
        id="fe1007"
      />

      <InputTextComponent
        inputText={'utm_source'}
        value={formData.utm_source}
        type={'hidden'}
        id="fe1008"
      />

      <InputTextComponent
        inputText={'utm_content'}
        value={formData.utm_content}
        type={'hidden'}
        id="fe1009"
      />

      <InputTextComponent
        inputText={'utm_campaign'}
        value={formData.utm_campaign}
        type={'hidden'}
        id="fe1010"
      />

      <InputTextComponent
        inputText={'lastName'}
        value={formData.lastName}
        type={'hidden'}
        id="fe1014"
      />
      <InputTextComponent
        inputText={'secondLastName'}
        value={formData.secondLastName}
        type={'hidden'}
        id="fe1015"
      />

      <InputTextComponent
        inputText={'canalOrigen'}
        value={formData.canalOrigen}
        type={'hidden'}
        id="fe1016"
      />

      <InputTextComponent
        inputText={'producto'}
        value={formData.producto}
        type={'hidden'}
        id="fe1017"
      />

      <InputTextComponent
        inputText={'urlConfirmacion'}
        value={formData.urlConfirmacion}
        type={'hidden'}
        id="fe1011"
      />

      <InputTextComponent
        inputText={'enviarCRM'}
        value={formData.enviarCRM}
        type={'hidden'}
        id="fe1012"
      />
    </form>
  );
};

export default EloquaFormComponent;
